<template>
  <div id="neopass_form_portfolio">
    <media-manager-popup 
      :data-to-show="isAddNewPopupDisplayed"
      @close="isAddNewPopupDisplayed = false"
      @newMedia="getMedias"
      :categories="categories"
      ref="mediaManager"
    />
        
    <preview-media
      :data-to-show="isPreviewPopupDisplayed" 
      :file="mediaToDisplay"
      @close="displayPopupPreview(false)"
    />

    <edit-category-popup 
      :data-to-show="isEditCategoryPopupDisplayed" 
      :old-category="categoryToEdit"
      :errors="{}"
      @editCategory="(newCategory) => { editCategory(newCategory) }"
      @close="closeEditCategoryPopup()"
      ref="editCategoryPopup"
    />

    <delete-category-popup 
      :category="categoryToEdit"
      :data-to-show="isDeleteCategoryPopupDisplayed"
      @deleteCategory="(category) => {deleteCategory(category)}"
      @close="closeDeleteCategoryPopup()"
    />

    <h3 
      class="
                mx-5 mt-5 mb-15
                md:mx-15 md:mt-15
                2xl:mx-20 2xl:mt-20 2xl:mb-20
            "
    >
      Portfolio
    </h3>
        
    <div
      v-if="listMedias.length > 0"
      class="m-5 lg:m-15 relative"
      @click.stop="hideCategoryMenu"
    >
      <!-- Categories list -->
      <div
        class="flex justify-center items-center mb-20 pb-5"
      >
        <ul class="flex justify-between md:justify-center md:space-x-10 overflow-x-auto text-2xl w-2/3 md:w-full no-scroll-bar">
          <li
            class="flex-shrink-0 inline-block cursor-pointer duration-300 transition-colors hover:text-indigo-600 hover:font-normal"
            :class="{
              'text-gray-600 font-light' : categoriesFilter != '',
              'text-pink-600 font-normal' : categoriesFilter == ''
            }"
            @click="categoriesFilter = ''; numPage = 1"
          >
            Toutes
          </li>
          <li
            v-for="(cat, i) in categories"
            :key="'A'+i"
            class="flex-shrink-0 flex items-center cursor-pointer duration-300 transition-colors hover:text-indigo-600 hover:font-normal pl-4 md:pl-0"
            :class="{
              'text-gray-600 font-light' : categoriesFilter != cat,
              'text-pink-600 font-normal' : categoriesFilter == cat
            }"
            @click.stop="categoriesFilter = cat; numPage=1"
          >
            {{ cat }}
            <span
              v-if="canEditPortfolio"
              @click.stop="showCategoryMenu(i)"
              class="group-hover:block text-pink-600"
              :class="{
                'block': numCategoryMenuDisplayed === i || categoriesFilter === cat,
                'hidden': numCategoryMenuDisplayed != i && categoriesFilter != cat
              }"
            >
              <icon
                name="more-vertical"
                class="w-5"
              />
            </span>
            <div
              v-if="numCategoryMenuDisplayed == i"
              class="absolute rounded-xl bg-white text-gray-600 shadow-lg shadow-gray-600 text-sm w-max max-w-full lg:max-w-128 p-5 top-8 right-8 flex flex-col space-y-2 z-10"
            >
              <div
                class="hover:text-gray-900"
                @click.stop="displayEditCategoryPopup(cat)"
              >
                Modifier
              </div>
              <div
                class="hover:text-gray-900"
                @click.stop="displayDeleteCategoryPopup(cat)"
              >
                Supprimer
              </div>
            </div>
          </li>
        </ul>
        <icon
          class="ml-3 text-indigo-600 md:hidden block"
          name="arrow-right_1"
        />
      </div>
      <!-- END Categories list -->

      <!-- Button to add a picture --> 
      <add-button 
        libelle="Ajouter un média"
        @add="openAddNewMediaPopup"
        class="relative"
      />
      <!-- END Button to add a picture --> 

      <!-- Pictures list -->
      <div class="mt-15 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 xxl:grid-cols-3 gap-y-15 lg:gap-x-15 z-10">
        <media-card
          v-for="(media, i) in displayedMedias"
          :key="i" 
          :file="media"
          :editable="canEditPortfolio"
          :id="i"
          @openFile="showMedia(media)"
          @deleteFile="deleteMedia(media)"
          @editFile="openMediaModifyPopup(media)"
          class="justify-self-center"
        />
      </div>  
      <div
        v-if="numPage > 0 || numPage < (pageCount-1)"
        class="w-full mt-15 flex justify-center items-center space-x-2"
      >
        <div 
          @click="prevPage" 
          class="cursor-pointer text-gray-600"
          :class="{'text-indigo-600' : numPage > 1}"
        >
          <icon
            class="h-4 w-3 mr-2"
            name="chevron-left"
          />
        </div> 
        <div class="text-2xl text-gray-600 flex">
          <div :class="{'text-indigo-600' : numPage > 1}">
            {{ numPage }}
          </div>
          <div>/</div>
          <div :class="{'text-indigo-600' : numPage < (pageCount)}">
            {{ pageCount }}
          </div> 
        </div>  
        <div 
          @click="nextPage" 
          class="cursor-pointer text-gray-600"
          :class="{'text-indigo-600' : numPage < (pageCount)}"
        >
          <icon
            name="chevron-right"
            class="h-4 w-3 ml-2"
          />
        </div>
      </div>
      <!-- END Pictures list -->
    </div>
    <div v-if="listMedias.length == 0">
      <div class="text-gray-600 flex flex-col space-y-2 text-center mb-10">
        <p> 
          <span>{{ user.id == infosPass.id_pass ? "Votre" : "Le" }}</span> portfolio est vide
        </p>
        <p v-if="canEditPortfolio">
          commencez par déposer votre premier média.
        </p>
      </div>
      <div class="flex flex-col items-center space-y-15">
        <action-button
          v-if="canEditPortfolio"
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-indigo-600"
          bg-color-square="bg-indigo-600"
          icon-color="text-white"
          libelle="DÉPOSER UN Média"
          :uppercase="true"
          icon="file-add"
          type-shadow="indigo-shadow"
          @clickAction="openAddNewMediaPopup"
        />
        <illustration name="evaluation" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import axios from './../../../api';
import ClickOutside from 'vue-click-outside';
import Constants from './../../../constants';

import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';

import Icon from '../../../components/Icon';
import Illustration from '../../../components/Illustration.vue';

import AddButton from '../../../components/Inputs/AddButton.vue';
import ActionButton from '../../../components/ActionButton.vue';
import MediaCard from './../../../components/Portfolio/MediaCard.vue';

import MediaManagerPopup from '../../../components/Portfolio/MediaManagerPopup.vue';
import PreviewMedia from '../../../components/Portfolio/PreviewMedia.vue';
import EditCategoryPopup from './../../../components/Portfolio/EditCategoryPopup.vue';
import DeleteCategoryPopup from '../../../components/Portfolio/DeleteCategoryPopup.vue';

export default {
  components: {
    InputText,
    InputTextArea,
    MultipleSelect,
    Icon,
    AddButton,
    MediaManagerPopup,
    ActionButton,
    Illustration,
    MediaCard,
    PreviewMedia,
    DeleteCategoryPopup,
    EditCategoryPopup
  },

  name: 'Portfolio',
    
  data() {
    return {
      constants: Constants,
      listMedias:[],
            
      picTemp:{
        id: null,
        path: '',
        filename: '',
        name: '',
        description: '',
        categories: [],
      },
            
      mediaToDisplay: {},
      categoryToEdit: '',

      isAddNewPopupDisplayed: false,
      isPreviewPopupDisplayed: false,
      numCategoryMenuDisplayed: -1,
      isEditCategoryPopupDisplayed: false,
      isDeleteCategoryPopupDisplayed: false,

      errorsDeleteMedia:{},

      numPage: 1,
      mediaPerPage: 9,

      categoriesFilter:'',
    };
  },

  mounted(){
    this.getMedias();
  },

  methods: {
    openAddNewMediaPopup(){
      this.isAddNewPopupDisplayed = true;
      this.$refs.mediaManager.mode = 'new';
    },

    openMediaModifyPopup(media){
      this.$refs.mediaManager.fileTemp = JSON.parse(JSON.stringify(media));
      this.$refs.mediaManager.step = 2;
      this.$refs.mediaManager.mode = 'edit';
      this.isAddNewPopupDisplayed = true;
    },

    async getMedias(){
      await axios.get('api/portfolio/medias/'+this.infosPass.id_pass).then((response) => {
        this.listMedias = response.data;
      }).catch(error => {
        console.log(error);
      });
    },

    async deleteMedia(media){
      await axios.put('api/portfolio/delete/'+this.infosPass.id_pass, media).then((response) => {
        this.getMedias();
      }).catch(error => {
        console.log(error);
      });
    },

    async editCategory(newCategory){
      await axios.put(
        'api/portfolio/editCategory/'+this.infosPass.id_pass, 
        {oldCategory: this.categoryToEdit, newCategory: newCategory}
      ).then((response) => {
        this.getMedias();
        if(this.categoriesFilter === this.categoryToEdit) this.categoriesFilter = newCategory;
        this.closeEditCategoryPopup();
      }).catch(error => {
        console.log(error);
      });
    },

    async deleteCategory(category){
      await axios.put(
        'api/portfolio/deleteCategory/'+this.infosPass.id_pass, 
        { category: category }
      ).then((response) => {
        this.getMedias();
        if(this.categoriesFilter === category) this.categoriesFilter = '';
        this.closeDeleteCategoryPopup();
      }).catch(error => {
        console.log(error);
      });
    },

    showMedia(media){
      this.displayPopupPreview(true);
      this.mediaToDisplay = media;
    },

    displayPopupPreview(state){
      this.isPreviewPopupDisplayed = state;
    },

    displayEditCategoryPopup(cat){
      this.categoryToEdit = cat;
      this.numCategoryMenuDisplayed = -1;
      this.$refs.editCategoryPopup.category = cat;
      this.isEditCategoryPopupDisplayed = true;
    },

    displayDeleteCategoryPopup(cat){
      this.categoryToEdit = cat;
      this.numCategoryMenuDisplayed = -1;
      this.isDeleteCategoryPopupDisplayed = true;
    },

    closeEditCategoryPopup(){
      this.$refs.editCategoryPopup.category = '';
      this.numCategoryMenuDisplayed = -1;
      this.isEditCategoryPopupDisplayed = false;
    },

    closeDeleteCategoryPopup(){
      this.categoryToEdit = '';
      this.numCategoryMenuDisplayed = -1;
      this.isDeleteCategoryPopupDisplayed = false;
    },

    showCategoryMenu(index){
      this.numCategoryMenuDisplayed = index;
    },

    hideCategoryMenu(){
      this.numCategoryMenuDisplayed = -1;
    },

    nextPage(){
      if(this.numPage === this.pageCount) return;
      this.numPage++;
    },
        
    prevPage(){
      if(this.numPage === 1) return;
      this.numPage--;
    },


  },
  computed: {
    ...mapGetters({
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      user: 'auth/user'
    }),

    canEditPortfolio(){
      return this.$can(Constants.PERMISSION_NEOPASS_FORM_PORTFOLIO_EDITER, this.infosPass.id_pass);
    },

    pageCount: function(){
      let l = this.filteredMedias.length,
        s = this.mediaPerPage;
      return Math.ceil(l/s);
    },

    displayedMedias(){
      let indexBegun = (this.numPage-1)*this.mediaPerPage;
      let medias = this.filteredMedias.filter((media, index) => index >= indexBegun && index < indexBegun+this.mediaPerPage);
            
      return medias;
    },

    categories(){
      let cats = this.listMedias.reduce((acc, media) => [...acc, ...media.categories], []);
            
      //delete doublons
      cats = cats.filter((cat, index) => cats.indexOf(cat) === index);

      //Sort
      cats = cats.sort();  
            
      return cats;
    },

    filteredMedias(){
      return this.listMedias.filter(media => this.categoriesFilter == '' || media.categories.includes(this.categoriesFilter));
    }
  },
  directives:{
    ClickOutside,
  }
};
</script>
<style scoped>
/* Masquer la barre de défilement dans Chrome, Safari et autres navigateurs WebKit */
::-webkit-scrollbar {
  display: none;
}

.no-scroll-bar{
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>